export default {
  FESTIVALS: [
    'https://cdn.ticketswap.com/static/images/festivals-cover-1.jpg',
    'https://cdn.ticketswap.com/static/images/festivals-cover-2.jpg',
    'https://cdn.ticketswap.com/static/images/festivals-cover-3.jpg',
    'https://cdn.ticketswap.com/static/images/festivals-cover-4.jpg',
  ],
  CONCERTS: [
    'https://cdn.ticketswap.com/static/images/concerts-cover-1.jpg',
    'https://cdn.ticketswap.com/static/images/concerts-cover-2.jpg',
    'https://cdn.ticketswap.com/static/images/concerts-cover-3.jpg',
    'https://cdn.ticketswap.com/static/images/concerts-cover-4.jpg',
    'https://cdn.ticketswap.com/static/images/concerts-cover-5.jpg',
    'https://cdn.ticketswap.com/static/images/concerts-cover-6.jpg',
    'https://cdn.ticketswap.com/static/images/concerts-cover-7.jpg',
  ],
  CLUBS: [
    'https://cdn.ticketswap.com/static/images/club-nights-cover-1.jpg',
    'https://cdn.ticketswap.com/static/images/club-nights-cover-2.jpg',
  ],
  SPORTS: ['https://cdn.ticketswap.com/static/images/sports-cover-1.jpg'],
  VOUCHERS_AND_DAY_OUT: [
    'https://cdn.ticketswap.com/static/images/vouchers-days-out-cover-1.jpg',
  ],
  default: [
    'https://cdn.ticketswap.com/static/images/event-cover-1.jpg',
    'https://cdn.ticketswap.com/static/images/event-cover-2.jpg',
    'https://cdn.ticketswap.com/static/images/event-cover-3.jpg',
    'https://cdn.ticketswap.com/static/images/event-cover-4.jpg',
  ],
}
